import { ToDecimal } from 'utils'
export default {
  methods: {
    MakeUpNumber (val) { // 个位数字补0
      return val < 10 ? `0${val}` : val
    },
    NegativeColor (val) {
      let result = { class: {} }
      if (val < 0) result.class = { pc1: true } 
      return result
    },
    numberMath (val) { //  金额逗号(小数点转整数(参数))
      return this.$commaFormat(Math.round(val))
    },
    checkFooterText (val) { // 表格判断footer行
      const array = ['总计', '小计', '本占比总计']
      return array.some(it => it == val)
    },
    defaultRender (h, params, key) { // 判断是否不是footer行才进行渲染
      return !this.checkFooterText(params.row.name) ? h('p', this.numberMath(params.row[key])) : ''
    },
    renderColorAmount (h, params, key) {
      return h('p', this.NegativeColor(params.row[key]), this.toDecimal2(params.row[key]))
    },
    toDecimal2 (value) {
      return this.$commaFormat(ToDecimal(value))
    }
  }
}